import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useTable, useSortBy, useFilters, usePagination } from "react-table";
import { Icon, Pagination, Popup, Dropdown, Input, Button } from "semantic-ui-react";
import NothingToShow from "../../../../drive/NothingToShow";

const DefaultColumnFilter = ({ column: { filterValue, setFilter, Header } }) => (
  <Input
    value={filterValue || ''}
    onChange={(e, { value }) => setFilter(value)}
    placeholder={`${Header}...`}
    size="small"
    fluid
    style={{ fontSize: '10px' }}
  />
);

const ConsumptionTable = ({ data , column }) => {
  const columns = useMemo(
    () => column ? column : [],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, sortBy, filters },
    resetResizable,
    setSortBy,
  } = useTable(
    {
      columns,
      data,
      // defaultColumn: { Filter: DefaultColumnFilter },
      initialState: { pageSize: 50 },
    },
    // useFilters,
    // useSortBy,
    usePagination
  );

  const handleResetFilters = () => {
    headerGroups.forEach((headerGroup) => {
    headerGroup.headers.forEach((header) => {
      if (header.setFilter) header.setFilter(undefined);
    });
  });

  setSortBy([]);
  };

  const tooltip = (name, content) => (
    <Popup
      trigger={<Icon name={name} style={{ cursor: "pointer" }} />}
      content={content}
      position="top center"
      inverted
      size="mini"
    />
  );

  return (
    <div
      style={{
        width: "100%",
        border: "1px solid #D3D3D3",
        borderRadius: "4px",
      }}
    >
      <table
        className="react-table-consumption"
        {...getTableProps()}
        style={{ borderCollapse: "collapse", width: "100%" }}
      >
        <thead className="table-header">
          {/* Header Row */}
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  className={`table-cell-header
                    ${column.isSorted ? "active" : ""}
                      `}
                  {...column.getHeaderProps()}
                  style={{
                    border: "1px solid #D3D3D3",
                    padding: "10px",
                    cursor: column.canSort ? "pointer" : "default",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {column.render("Header")}
                    <span
                      style={{ marginLeft: "4px" }}
                      onClick={() =>
                        column.toggleSortBy(!column.isSortedDesc, false)
                      }
                    >
                      {/* {column.isSorted ? (
                        column.isSortedDesc ? (
                          <Icon name="sort down" />
                        ) : (
                          <Icon name="sort up" />
                        )
                      ) : (
                        <Icon name="sort" style={{ color: "#999" }} />
                      )} */}
                    </span>
                  </div>
                </th>
              ))}
            </tr>
          ))}

          {/* Filter Row */}
          {/* {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  style={{
                    border: "1px solid #D3D3D3",
                    padding: "6px",
                  }}
                >
                  {column.canFilter ? column.render("Filter") : null}
                </th>
              ))}
            </tr>
          ))} */}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length}
                style={{
                  padding: "16px",
                  textAlign: "center",
                  border: "1px solid #D3D3D3",
                }}
              >
                <NothingToShow imgStyle={{ display: "block" }} />
              </td>
            </tr>
          ) : (
            page.map((row) => {
              prepareRow(row);
              return (
                <tr className="table-row" {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td
                      {...cell.getCellProps()}
                      style={{
                        padding: "10px",
                        border: "1px solid #D3D3D3",
                      }}
                    >
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })
          )}
        </tbody>

        <tfoot
          style={{
            padding: "3px",
            border: "1px solid #D3D3D3",
            backgroundColor: "rgb(243 244 246)",
          }}
        >
          {/* <tr>
            <td
              colSpan={columns.length}
              style={{ padding: "3px", background: "#f8f9fa" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "3px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "16px" }}
                >
                  <Button
                  onClick={handleResetFilters}
                  basic
                  size="small"
                  className="ui button primary"
                >
                  Reset Filters
                </Button>
                  Total Records: <b>{data.length}</b>
                  Records Per Page :{" "}
                  <Dropdown
                    inline
                    direction="upward"
                    value={pageSize}
                    options={[5, 10, 50, 100].map((size) => ({
                      key: size,
                      text: size,
                      value: size,
                    }))}
                    onChange={(e, { value }) => setPageSize(Number(value))}
                  />{" "}
                  &nbsp;&nbsp;&nbsp;&nbsp; Go to Page{" "}
                  <Dropdown
                    inline
                    scrolling
                    direction="upward"
                    value={pageIndex + 1}
                    options={Array.from(
                      { length: pageCount },
                      (_, index) => index + 1
                    ).map((i) => {
                      return {
                        key: i,
                        text: i,
                        value: i,
                      };
                    })}
                    onPageChange={(e, { value }) => gotoPage(value)}
                  />{" "}
                  </div>
                <div style={{padding:'3px'}}>
                  <Pagination
                    activePage={pageIndex + 1}
                    totalPages={pageCount}
                    onPageChange={(e, { activePage }) =>
                      gotoPage(activePage - 1)
                    }
                    ellipsisItem={tooltip("ellipsis horizontal", "More pages")}
                    firstItem={tooltip("angle double left", "First page")}
                    lastItem={tooltip("angle double right", "Last page")}
                    prevItem={tooltip("angle left", "Previous page")}
                    nextItem={tooltip("angle right", "Next page")}
                    className="paginationContainer"
                  />
                </div>
              </div>
            </td>
          </tr>  */}
        </tfoot>
      </table>
    </div>
  );
};

ConsumptionTable.propTypes = {
  data: PropTypes.array.isRequired,
};

export default ConsumptionTable;
